// @ts-check
import { LBButton } from '@linearb/buzz';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

const PostJiraIntegration = ({ buttonText }) => {
  return (
    <Text
      size='large'
      color='shuttleGray'
      mt='1rem'
      mb='1rem'
      lineHeight='2.4rem'
    >
      Thanks for following the steps on Jira, <br />
      click "{buttonText}" below to finalize your connection
    </Text>
  );
};

const JiraConnectStep3 = props => {
  const { disabled, reauthorize = false, onFinish } = props;

  const buttonText = reauthorize ? 'Reauthorize' : 'Connect';
  return (
    <Flex
      justify='space-between'
      content='flex-start'
      items='flex-start'
      direction='column'
    >
      <PostJiraIntegration buttonText={buttonText} />
      <Flex
        {...(reauthorize ? { justify: 'flex-end' } : { pt: 'small' })}
        width='100%'
      >
        <LBButton disabled={disabled} onClick={onFinish} size='lg'>
          {buttonText}
        </LBButton>
      </Flex>
    </Flex>
  );
};
export default JiraConnectStep3;
